import { render, staticRenderFns } from "./StationDetails.vue?vue&type=template&id=9834446c&"
import script from "./StationDetails.vue?vue&type=script&lang=ts&"
export * from "./StationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports